<template>
  <div class="card">
    <div class="card-body m-2">
      <form @submit.prevent="onSubmit">
        <div class="form-group row">
          <label for="password">Wachtwoord</label>
          <input
            id="password"
            type="password"
            class="form-control"
            :class="{'is-invalid': $v.password.$error, 'is-valid': !$v.password.$error && $v.password.$dirty}"
            v-model="password"
            @blur="$v.password.$touch()"
          >
          <span v-if="!$v.password.minLen" class="invalid-feedback" role="alert">
            <strong>Uw wachtwoord moet tenminste {{ $v.password.$params.minLen.min }} karakters bevatten.</strong>
          </span>
          <span v-if="!$v.password.required" class="invalid-feedback" role="alert">
            <strong>Vul a.u.b. uw wachtwoord in</strong>
          </span>
        </div>
        <div class="form-group row">
          <label for="confirm-password">Bevestig wachtwoord</label>
          <input
            id="confirm-password"
            type="password"
            class="form-control"
            :class="{'is-invalid': $v.confirmPassword.$error, 'is-valid': !$v.confirmPassword.$error && $v.confirmPassword.$dirty}"
            v-model="confirmPassword"
            @blur="$v.confirmPassword.$touch()"
          >
          <span v-if="$v.confirmPassword.$error" class="invalid-feedback" role="alert">
            <strong>Zorg er voor dat de wachtwoorden gelijk zijn!</strong>
          </span>
          <span v-if="!$v.password.required" class="invalid-feedback" role="alert">
            <strong>Vul a.u.b. de wachtwoord bevestiging in</strong>
          </span>
        </div>

        <div class="form-group row mb-0">
          <div
            v-if="passwordResetStatus"
            class="col-md-13 alert"
            role="alert"
            :class="{ 'alert-success': passwordResetStatus.success, 'alert-danger': !passwordResetStatus.success }"
          >
            <strong>{{ passwordResetStatus.message }}</strong>
          </div>

          <div class="col-md-13">
            <button
              type="submit"
              class="btn btn-oldevuuren w-100 btn-round"
              :disabled="$v.$invalid"
              :class="{'disabled cursor-not-allowed': $v.$invalid}"
            >
              Wachtwoord instellen
              <font-awesome-icon class="font-awesome-icon" v-if="passwordResetBusy" icon="spinner" spin/>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { minLength, required, sameAs } from 'vuelidate/lib/validators'

  import { RESET } from '../../store/types'

  export default {
    data() {
      return {
        password: '',
        confirmPassword: ''
      }
    },
    props: ['token', 'email'],
    created() {
      // Make sure the slug exists, otherwise redirect user?
      // console.log(this.token)
      // console.log(this.email)
    },
    computed: {
      passwordResetStatus() {
        return this.$store.getters.passwordResetStatus
      },
      passwordResetBusy() {
        return this.$store.getters.passwordResetBusy
      }
    },
    validations: {
      password: {
        required,
        minLen: minLength(8)
      },
      confirmPassword: {
        required,
        minLen: minLength(8),
        sameAs: sameAs(vm => {
          return vm.password
        })
      }
    },
    methods: {
      onSubmit() {
        const formData = {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword
        }

        this.$store.dispatch(RESET, formData)
      }
    }
  }
</script>

<style lang="scss" scoped>
  label {
    font-weight: normal;
    text-transform: uppercase;
  }
</style>
